<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->
<div class="text-area-container" [class.disabled]="disabled" [class.has-error]="hasError" [class.focused]="isFocused">
  <label *ngIf="label" class="input-label">
    <hyperkit-typography variant="label1" color="primary">
      {{ label }}
    </hyperkit-typography>
  </label>
  <div class="text-area-wrapper">
    <textarea
      [placeholder]="placeholder"
      [value]="value"
      [disabled]="disabled"
      (input)="onInput($event)"
      (focus)="onFocus()"
      (blur)="onBlur()">
    </textarea>
  </div>
  <div *ngIf="hint" class="hint-container">
    <hyperkit-typography variant="body2" color="inherit">
      {{ hint }}
    </hyperkit-typography>
  </div>
  <div *ngIf="hasError" class="hint-container">
    <hyperkit-error [error]="errorMessage"></hyperkit-error>
  </div>
</div>